import { memo } from "react"

import { ChatMessage } from "./chatMessage"

export default memo(ChatMessage)
